<template>
  <div class="product">
    <div class="breadcrumbs">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
        <svg class="icon" aria-hidden="true" style="fill: #fff">
          <use xlink:href="#icon-shangpin"></use>
        </svg>
      </breadcrumbs>
    </div>
    <a-spin :spinning="spinning">
      <div class="content-wrap">
        <pulic-report-notice type="urgent" @click="() => getProductVariations('active')"
          v-if="detailData.status === 'inactive'">
          <template #title>{{ $t('seller.productDetail.inactiveProductBanner') }}</template>
          <template #action>{{ $t('seller.productDetail.activateProductAction') }}</template>
        </pulic-report-notice>
        <div class="content">
          <div class="content-top">
            <div class="left">
              <!-- <img :src="detailData.imageUrl" v-if="detailData.imageUrl" /> -->
              <div :class="'top-img' + (detailData?.imageUrl ? '' : ' show-bg')">
                <a target="_blank" :href="productUrl"><a-image :src="selectImageUrl || detailData.imageUrl"
                    v-if="detailData.imageUrl" :preview="false" /></a>
              </div>
              <div class="bottomUrlContainer" v-if="detailData?.imageUrls?.length">
                <div class="bottomUrl">
                  <div v-for="(item, index) in detailData?.imageUrls" @mouseover="changeImageUrl(item, index)" :style="{
                    border:
                      selectImageIndex === index
                        ? '1px solid var(--Brand-Primary, #6C3DF2)'
                        : '',
                  }" :key="index" class="bottomUrlItem">
                    <a-image :src="item" :preview="false" />
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="detail" ref="detailRef">
                <div class="title">
                  <div class="title-head">
                    <p>{{ detailData.title }}</p>
                    <!-- <div class="operation" v-if="detailData.status === 'active'">
                      <a-dropdown :trigger="['click']" :getPopupContainer="(triggerNode) => triggerNode.parentNode
                        ">
                        <artmisads-select-button>
                          <svg class="icon" aria-hidden="true" style="font-size: 20px; font-weight: 500">
                            <use xlink:href="#icon-gengduo"></use>
                          </svg>
                        </artmisads-select-button>
                        <template #overlay>
                          <a-menu>
                            <a-menu-item @click="getProductVariations('deactivate')"
                              style="white-space: nowrap; margin: 4px">
                              Deactivate Products
                            </a-menu-item>
                          </a-menu>
                        </template>
                      </a-dropdown>
                   
                    </div> -->
                  </div>
                  <div class="asin-vc-icon">
                    <a target="_blank" :href="detailData.productUrl">{{ $t('seller.productDetail.amazonDetailPage') }}
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-tiaozhuan"></use>
                      </svg>
                    </a>
                    <VcIcon v-if="detailData.amazonProfileAccountInfoType == 'vendor'" type="Products" />
                  </div>
                </div>
                <div class="items">
                  <div class="item">
                    <span>{{ $t('seller.productTable.labelAsin') }}</span>
                    <span>{{ detailData.asin }}</span>
                  </div>
                  <div class="item">
                    <span>{{ $t('seller.productDetail.labelBrand') }}</span>
                    <span><a :href="`/seller/brand/detail/${detailData.brandId}`" target="_blank">{{
                      detailData.brandName
                        }}{{
                          detailData.amazonProfileAccountInfoName
                            ? ` (${detailData.amazonProfileAccountInfoName})`
                            : ''
                        }}</a></span>
                  </div>
                  <div class="item">
                    <span>{{ $t('seller.productDetail.labelPrice') }}</span>
                    <price-deal-layout v-if="detailData.combineDeal" :record="detailData.combineDeal" />
                    <span v-else>{{ detailData.currencySymbol
                    }}{{ Number(detailData.price || 0).toFixed(2) }}</span>
                  </div>
                  <div class="item">
                    <span>{{ $t('seller.productDetail.labelCategory') }}</span>
                    <span>{{ detailData.category }}</span>
                  </div>
                  <div class="item">
                    <span>{{ $t('seller.productDetail.labelBestSellerRank') }}</span>
                    <span>{{ detailData.bestSellerRank }}</span>
                  </div>
                  <div class="item">
                    <span>{{ $t('seller.productDetail.labelAvailability') }}</span>
                    <span>{{ availabilityDisplay }}</span>
                  </div>
                  <!-- <div class="item">
                    <span>Commission:</span>
                    <span class="edit-commission">
                      <artmisads-button :isSquare="true" type="primary" size="middle" class="commission" @click="
                        () => {
                          setSelectSingleProduct(detailData.id)
                          setShowSetCommission(true)
                        }
                      ">
                        <span class="text">{{ detailData.commission?.toFixed(1) }}%</span>
                        <EditOutlined />
                      </artmisads-button>
                      <a-button class="history" @click="
                        () => {
                          setSelectSingleProduct(detailData.id)
                          setShowCommissionHistory(true)
                        }
                      "><i class="iconfont icon-lishijilu" /></a-button>
                    </span>
                  </div> -->
                  <!-- <div class="item">
                    <span>Status:</span>
                    <span style="opacity: 1">
                      <showStatus :isActive="detailData.status === 'active'" />
                    </span>
                  </div> -->
                </div>
                <div class="bottomBox">
                  <div class="bottom-body">
                    <div class="bottom-body-item">
                      <div class="item">
                        <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon" />
                        <span class="item-text">{{ $t('seller.productDetail.attribution') }}</span>
                      </div>
                      <div class="status-box">
                        <div class="status-box-title">{{ $t('seller.productDetail.sectionStatus') }}</div>
                        <showStatus type="Attribution" @editClick="editClick" :isActive="detailData.status == 'active'"
                          :showEditBtn="true" />
                      </div>
                    </div>
                    <div class="commission-box">
                      <div class="status-box-title">{{ $t('seller.productDetail.sectionCommission') }}</div>
                      <div class="commission-box-content">
                        <div class="commission-box-content-text">
                          {{ detailData.commission }}%
                        </div>
                        <SvgIcon name="bianji" class="icon-info" style="cursor: pointer" @click.stop="
                          () => {
                            setSelectSingleProduct(detailData?.id)
                            setShowSetCommission(true)
                          }
                        " />
                      </div>
                      <div>
                        <SvgIcon name="lishijilu" class="icon-info-lishijilu" style="cursor: pointer" @click.stop="
                          () => {
                            setSelectSingleProduct(detailData?.id)
                            setShowCommissionHistory(true)
                          }
                        " />
                      </div>
                    </div>
                  </div>
                  <!-- <div class="bottom-body">
                    <div class="bottom-body-item">
                      <div class="item">
                        <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon" />
                        <span class="item-text">{{ $t('seller.productDetail.associate') }}</span>
                      </div>
                      <div class="status-box">
                        <div class="status-box-title">{{ $t('seller.productDetail.sectionStatus') }}</div>
                        <showStatus type="Associate" @editClick="editClick"
                          :isActive="detailData.associateStatus == 'active'" :showEditBtn="true" />
                      </div>
                    </div>
                    <div style="flex: 1"></div>
                  </div> -->
                </div>
                <div class="title deals-section">
                  <div class="title-head">
                    <p class="sub-title">
                      {{ $t('seller.productDetail.dealsTitle') }}
                      <artmisads-select-button class="add-deal" @click="handleAddNewDeal">
                        <svg class="icon" aria-hidden="true" style="font-size: 20px; margin-right: 8px">
                          <use xlink:href="#icon-jiahao"></use>
                        </svg>{{ $t('seller.productDetail.addNewDeal') }}</artmisads-select-button>
                    </p>
                  </div>
                  <ProductDeals :dataSource="detailData.productDeals" :showEdit="true" @edit="editDeal" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="false" class="content-bottom">
            <div class="creators">
              <p>{{ $t('seller.productDetail.creatorsTitle') }}</p>
              <div class="content-bottom-wrap">
                <div class="content">
                  <svg class="icon" aria-hidden="true" style="fill: rgba(15, 6, 41, 0.5)">
                    <use xlink:href="#icon-kongshuju"></use>
                  </svg>
                  <p>{{ $t('seller.productDetail.noCreatorsPromoting') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <setPublicCommission :type="'product-detail'" :showSetCommission="showSetCommission" :productList="detailData"
        :selectedRowKeys="[]" :setShowSetCommission="setShowSetCommission" :getProductList="getProductDetail"
        :selectSingleProduct="selectSingleProduct" :setSelectSingleProduct="setSelectSingleProduct"
        v-if="detailData.id" />
      <commissionHistory :setShowCommissionHistory="setShowCommissionHistory"
        :showCommissionHistory="showCommissionHistory" :productId="productId" v-if="detailData.id" />
      <contextHolder />
    </a-spin>
    <variations class="seller-product-variations" v-if="detailData.variationTotal" :asin="detailData.asin"
      :id="route.params.id" userType="seller" :showStatus="true" :key="variationsKey" />
    <artmisads-modal v-model:open="showDeactivateModal" :title="$t('seller.productDetail.modalDeactivateTitle')"
      :width="500" :destroyOnClose="true" :maskClosable="false">
      <div class="inactive-content">
        <p v-if="hasVariations">
          {{ $t('seller.productDetail.modalDeactivateWithVariations') }}
        </p>
        <p v-else>
          {{ $t('seller.productDetail.modalDeactivateNoVariations') }}
        </p>
      </div>
      <template #footer>
        <artmisads-button @click="() => setShowDeactivateModal(false)">{{ $t('seller.common.cancel') }}</artmisads-button>
        <artmisads-button @click="() => onChangeStatus('inactive')" type="primary">{{ $t('seller.common.confirm') }}</artmisads-button>
      </template>
    </artmisads-modal>
    <artmisads-modal v-model:open="showActiveModal" :width="500" :title="$t('seller.productDetail.modalActivateTitle')"
      :okText="$t('seller.common.confirm')" @ok="() => onChangeStatus('active')" @cancel="setShowActivateModal(false)">
      <div class="active-product">
        <div class="title-ext">
          {{ $t('seller.productDetail.modalActivateBody') }}
        </div>
      </div>
    </artmisads-modal>
    <dealEditModal v-if="editDealInfo.open" :editDealInfo="editDealInfo" :countryCode="detailData.countryCode"
      :productId="productId" @update:editDealInfo="showDealEditModal" />
    <!-- <artmisads-modal v-model:open="showDeactivateModal" :title="`Are you sure you want to Deactivate this Product?`"
      :width="500" :onCancel="onCancel" :destroyOnClose="true" :maskClosable="false">
      <div class="inactive-content">
        <p v-if="hasVariations">
          Deactivating a Product will archive the active Publisher/Creator links
          of the product and its related variations, and also make them
          unavailable to Publishers and Creators.
        </p>
        <p v-else>
          Deactivating a Product will archive all active Publisher/Creator
          links. and make this product unavailable to publishers and creators.
        </p>
      </div>
      <template #footer>
        <artmisads-button @click="() => setShowDeactivateModal(false)">Cancel</artmisads-button>
        <artmisads-button @click="confirmInactive" type="primary">Confirm</artmisads-button>
      </template>
    </artmisads-modal>
    <artmisads-modal v-model:open="showActiveModal" :width="500" title="Are you sure you want to Activate this Product?"
      okText="Confirm" @ok="activateProduct" @cancel="setShowActivateModal(false)">
      <div class="active-product">
        <div class="title-ext">
          Activate the Product, and both the product itself and its related
          variations will be activated.
        </div>
      </div>
    </artmisads-modal> -->
  </div>
</template>

<script lang="jsx" setup>
import moment from 'moment'
import { useRoute } from 'vue-router'
import { EditOutlined } from '@ant-design/icons-vue'
import { message, notification } from 'ant-design-vue'
import { computed, onMounted, ref, provide } from 'vue'
import { useI18n } from 'vue-i18n'
import SvgIcon from '~/components/SvgIcon.vue'

import showStatus from '../../Brands/components/showStatus.vue'
import PulicReportNotice from '@/components/PulicReportNotice.vue'
import { productsApi } from '../../../../server/index'
import breadcrumbs from '../../breadcrumbs.vue'
import setPublicCommission from '../setPublicCommission.vue'
import commissionHistory from './commissionHistory.vue'
import Variations from '~/components/variations.vue'
import ProductDeals from '~/components/ProductDeals.vue'
import PriceDealLayout from '~/components/PriceDealLayout'
import dealEditModal from './dealEditModal.vue'
import VcIcon from '~/components/VcIcon.vue'

const { t, locale } = useI18n()

const showActiveModal = ref(false)
const selectImageUrl = ref('')
const selectImageIndex = ref(0)
const route = useRoute()
const hasVariations = ref(false)
const showCommissionHistory = ref(false)

const showDeactivateModal = ref(false)
const showSetCommission = ref(false)
const selectSingleProduct = ref('')
const detailRef = ref(null)
const spinning = ref(true)
const productId = ref('')
const editDealInfo = ref({
  id: null,
  type: null,
  dateRange: [],
  fullPrice: '',
  finalPrice: '',
})
const changeImageUrl = (item, index) => {
  selectImageUrl.value = item
  selectImageIndex.value = index
}
const editType = ref('')
const variationsKey = ref(1)
const detailData = ref({})

const breadcrumbsData = computed(() => {
  locale.value
  return {
    title: t('seller.productDetail.breadcrumbTitle'),
    des: t('seller.productDetail.breadcrumbDes'),
    color: '#4682FA',
    links: [
      {
        name: t('seller.common.home'),
        path: '/seller/dashboard',
      },
      {
        name: t('seller.common.productsBreadcrumb'),
        path: '/seller/product',
      },
      {
        name: t('seller.productDetail.breadcrumbProductDetail'),
        path: `/seller/product/${productId.value}`,
      },
    ],
  }
})

const availabilityDisplay = computed(() => {
  locale.value
  const a = detailData.value.availiability
  if (a === 'IN_STOCK') return t('seller.brandsPage.inStock')
  return t('seller.brandsPage.outOfStock')
})
const [api, contextHolder] = notification.useNotification()
const openNotification = (description) => {
  api.info({
    message: t('seller.common.notice'),
    description: description,
    placement: 'topRight',
    duration: 3,
  })
}
const editClick = (type, isActive) => {
  editType.value = type
  if (isActive) {
    getProductVariations('deactivate')
  } else {
    getProductVariations('active')
  }
}
const setShowDeactivateModal = (status) => {
  showDeactivateModal.value = status
}
const setShowActivateModal = (status) => {
  showActiveModal.value = status
}

const setShowCommissionHistory = (status) => {
  console.log('执行了setShowCommissionHistory ')
  showCommissionHistory.value = status
}
const setShowSetCommission = (status) => {
  showSetCommission.value = status
}

const onChangeStatus = async (status) => {
  spinning.value = true
  showDeactivateModal.value = false
  showActiveModal.value = false

  let res,
    params = [productId.value]

  if (status === 'active') {
    if (editType.value == 'Attribution') {
      res = await productsApi.activeProduct(params)
    } else {
      res = await productsApi.activeAssociateProduct(params)
    }
  } else {
    if (editType.value == 'Attribution') {
      res = await productsApi.inactiveProduct(params)
    } else {
      res = await productsApi.inactiveAssociateProduct(params)
    }
  }

  const { success, error, code } = res

  if (success) {
    if (status === 'active') {
      message.success(t('seller.productDetail.toastActivated'))
    } else {
      message.success(t('seller.productDetail.toastDeactivated'))
    }
    detailData.value.status = status
    variationsKey.value = !variationsKey.value
    getProductDetail(productId.value)
  } else {
    if (code === '1014') {
      openNotification(error)
    }
  }
  spinning.value = false
}

const getProductVariations = async (status) => {
  let hasVariation = false
  let res = await productsApi.getProductVariations([productId.value])

  if (
    res.data.activeProductVariationCount ||
    res.data.inactiveProductVariationCount
  ) {
    hasVariation = true
  }

  if (status == 'active') {
    if (hasVariation) {
      setShowActivateModal(true)
    } else {
      onChangeStatus('active')
    }
  }

  if (status == 'deactivate') {
    hasVariations.value = hasVariation

    setShowDeactivateModal(true)
  }
}
const getProductDetail = async (id) => {
  spinning.value = true
  const res = await productsApi.getProductDetail(id)
  const { success, data } = res

  if (success) {
    detailData.value = data
    detailData.value.imageUrls =
      detailData?.value?.imageUrls?.splice(0, 6) || []
  }

  spinning.value = false
}

const setSelectSingleProduct = (id) => {
  // console.log('执行了setSelectSingleProduct ', id)
  selectSingleProduct.value = id
}

async function handleAddNewDeal () {
  const res = await productsApi.checkDealStatus(productId.value)
  const { success, data } = res
  if (success && data == false) {
    message.warning(t('seller.productDetail.activateBeforeAddDeal'))
    return
  }

  showDealEditModal()
}

function showDealEditModal (data) {
  editDealInfo.value = {
    id: null,
    type: null,
    open: true,
    dateRange: [],
    fullPrice: '',
    finalPrice: '',
    ...data,
  }
}

// 保存Deal, 并更新列表
function saveDeal (index, deal) {
  if (index != undefined) {
    detailData.value.productDeals[index] = deal
  } else {
    detailData.value.productDeals.push(deal)
  }
}

// 编辑Deal
function editDeal (index, record) {
  editDealInfo.value = {
    ...record,
    open: true,
    index,
    dateRange: [moment(record.beginTime), moment(record.endTime)],
  }
}

function deleteDeal (index) {
  detailData.value.productDeals.splice(index, 1)
}

provide('saveDeal', saveDeal)
provide('deleteDeal', deleteDeal)

onMounted(() => {
  const { id } = route.params
  if (id) {
    productId.value = id
    getProductDetail(id)
  }
})
</script>

<style lang="less" scoped>
.bottomBox {
  border-radius: var(--Radius-Radius-8, 8px);
  background: #f8f7fc;
  margin-top: 37px;
}

.bottom-body {
  display: flex;
  gap: 12px;

  .commission-box {
    display: flex;
    flex: 1;
    align-items: center;
  }

  .icon-info-lishijilu {
    font-size: 18px;

    margin-left: 6px;
    margin-top: 4px;
    color: #0f0629;
    opacity: 0.5;
  }

  .commission-box-content {
    display: flex;
    padding: 3px 6px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: #fff;
    border-radius: var(--Radius-Radius-4, 4px);
    background: var(--Brand-Primary_Loading, #8a64f4);

    .commission-box-content-text {
      border-right: 1px solid #fff;
      padding-right: 18px;
      color: #ffffff;

      font-family: 'Sora';
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 14px;
      letter-spacing: 0.4px;
    }
  }

  .status-box-title {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.3px;
    opacity: 0.5;
    margin-right: 10px;
  }

  .bottom-body-item {
    padding: 16px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .item {
      display: flex;
      align-items: center;
      gap: 8px;

      .icon {
        width: 20px;
        height: 20px;
      }

      .item-text {
        color: #0f0629;

        font-family: 'Sora';
        font-size: 14px;
        font-style: normal;
        font-weight: 500;

        letter-spacing: 0.4px;
        opacity: 0.9;
      }
    }

    .status-box {
      display: flex;
    }
  }
}

.asin-vc-icon {
  display: flex;
  align-items: center;
  // justify-content: flex-end;
  gap: 14px;
}

.product {
  padding: 0 16px 16px;
}

.content {
  display: flex;
  flex-direction: column;
}

.content-top {
  display: flex;
  padding: 16px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: var(--section-box-shadow-6);
}

.left {
  width: 256px;
  height: 256px;
  border-radius: 8px;

  .top-img {
    width: 256px;
    height: 256px;
    border-radius: 8px;
    background: #eeedf2;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    :deep(img) {
      max-width: 256px !important;
      max-height: 256px !important;
      object-fit: contain;
    }

    &.show-bg {
      background-color: var(--bg-gray-2);
    }
  }

  .bottomUrlContainer {
    width: 256px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-bottom: 5px;

    /* 添加底部内边距，避免滚动条遮挡内容 */
    /* 滚动条样式美化 */
    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #a8a8a8;
    }
  }

  .bottomUrl {
    display: inline-flex;
    /* 改为inline-flex，配合父容器的white-space: nowrap */
    margin-top: 9px;
    gap: 8px;

    /* 添加间距，让图片项之间有间隔 */
    .bottomUrlItem {
      width: 45.6px;
      height: 45.6px;
      flex-shrink: 0;
      /* 防止图片项被压缩 */
      border-radius: var(--Radius-Radius-6, 6px);
      background: #eeedf2;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      cursor: pointer;
      transition: border-color 0.2s ease;

      :deep(img) {
        max-width: 44.6px !important;
        max-height: 43.6px !important;
        object-fit: contain;
      }
    }
  }

  img {
    width: 256px;
    height: 256px;
    border-radius: 8px;
    object-fit: contain;
  }

  >img {
    width: 256px;
    height: 256px;
    border-radius: 8px;
    object-fit: contain;
  }
}

.right {
  flex: 1;
  margin-left: 24px;

  .detail {
    :deep(.ant-popover) {
      width: 400px;

      .popconfirm-title {
        >p {
          font-weight: 400;
          font-size: 14px;
          color: var(--dark-1);
          letter-spacing: 0.4px;
          line-height: 22px;

          &:first-child {
            font-weight: 500;
            margin-bottom: 6px;
          }
        }
      }

      .ant-popover-inner {
        padding: 15px;
      }
    }

    .title {
      >.asin-vc-icon>a {
        color: var(--dark-1);
        background: var(--bg-gray-8);
        border-radius: 8px;
        padding: 0 8px;
        height: 28px;
        display: inline-flex;
        line-height: 28px;
        font-size: 16px;
        font-weight: 500;
        align-items: center;
        text-decoration: underline;

        &:hover {
          background: var(--bg-gray-5);
        }

        >.icon {
          margin-left: 8px;
          font-size: 20px;
        }
      }

      &.deals-section .title-head>p {
        margin-top: 40px;
      }

      .title-head {
        display: flex;
        justify-content: space-between;

        >p {
          flex: 1;
          font-weight: 600;
          font-size: 16px;
          color: var(--dark-1);
          letter-spacing: 0.5px;
          line-height: 22px;
          margin-top: 6px;
          margin-bottom: 16px;

          &.sub-title {
            display: flex;
            font-size: 20px;
            align-items: center;
            justify-content: space-between;

            >.add-deal {
              display: flex;
              font-size: 14px;
            }

            .iconfont {
              height: 22px;
            }
          }
        }

        .operation {
          position: relative;

          // align-self: center;
          >button {
            padding: 0 !important;
            width: 32px;
            font-size: 20px;
          }

          // > span {
          //   margin-left: 12px;
          //   width: 32px;
          //   > button {
          //     padding: 0 !important;
          //     width: 32px;
          //     font-size: 20px;
          //     > svg {
          //       width: 20px;
          //       height: 20px;
          //       vertical-align: -5px;
          //     }
          //   }
          // }

          >span {
            cursor: pointer;
            padding: 0 12px;
            background: #ffffff;
            border: 1px solid #ccc7d9;
            box-shadow: 0 1px 0 0 #0f06290d;
            border-radius: 8px;
            margin-left: 10px;
          }

          .inactive-btn {
            position: absolute;
            right: 0;
            display: none;
            // display: flex;
            padding-top: 10px;

            .deactivate {
              width: 180px;
              text-align: center;
              cursor: pointer;
              padding: 4px 12px;
              background: #ffffff;
              border: 1px solid #ccc7d9;
              box-shadow: 0 1px 0 0 #0f06290d;
              border-radius: 8px;
              margin-left: 10px;
            }
          }

          &:hover {
            .inactive-btn {
              display: flex;
            }
          }

          :deep(.ant-dropdown-menu-item) {
            color: var(--dark-1);
          }

          :deep(.ant-btn:not(:disabled):focus-visible) {
            outline: unset;
          }
        }
      }

      >p {
        font-weight: 400;
        font-size: 13px;
        color: var(--dark-1);
        letter-spacing: 0.3px;
        line-height: 18px;
        margin-top: 6px;
        text-decoration: underline;

        >a {
          color: var(--dark-1);
        }
      }
    }

    .items {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
      position: relative;

      &::after {
        left: 50%;
        top: 10px;
        content: '';
        position: absolute;
        width: 0;
        height: 110px;
        border-right: 1px solid #e8e5ed;
      }

      .item {
        width: 50%;
        display: flex;
        justify-content: space-between;

        &:nth-child(2n) {
          padding-left: 50px;
        }

        &:nth-child(2n + 1) {
          padding-right: 50px;
        }

        >span {
          line-height: 44px;
          font-size: 14px;
          align-self: center;
          color: var(--dark-3);
          font-weight: 500;

          &:last-child {
            font-weight: 600;
            color: var(--dark-1);
          }

          >a {
            color: var(--dark-1);
            text-decoration: underline;
          }
        }
      }

      .edit-commission {
        display: flex;

        >button {
          margin-left: 10px;
        }

        .commission {
          align-self: center;

          .text {
            padding-right: 12px;
            font-weight: 600;
            position: relative;

            &::after {
              content: '';
              position: absolute;
              right: 0;
              top: 2px;
              width: 0;
              height: 18px;
              border-right: 1px solid var(--border-5);
            }
          }

          >span {
            &:last-child {
              margin-left: 10px;
            }
          }
        }

        .history {
          border: none;
          padding: 0;
          line-height: 32px;
          display: flex;
          box-shadow: none;
          color: var(--dark-3);

          .iconfont {
            height: 26px;
            font-size: 20px;
            vertical-align: middle;
          }

          :deep(svg) {
            width: 20px;
            height: 20px;
            fill: var(--dark-3);
          }
        }
      }
    }
  }
}

.content-bottom {
  .creators {
    margin-top: 20px;
    background: #ffffff;
    border: 2px solid #e8e5ed;
    border-radius: 12px;

    .content-bottom-wrap {
      padding: 16px;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 85px 0 85px 0;
      background: #f8f7fc;
      border-radius: 8px;
      text-align: center;

      >svg {
        width: 96px;
        height: 96px;
        align-self: center;
      }

      >p {
        margin-top: 12px;
        opacity: 0.7;
        font-weight: 500;
        font-size: 18px;
        color: #0f0629;
        letter-spacing: 0.4px;
        line-height: 25px;
      }
    }

    >p {
      padding: 12px 16px;
      font-weight: 500;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      border-bottom: 1px solid #e8e5ed;
    }
  }
}

.seller-product-variations {
  padding: 16px;
  margin-top: 20px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: var(--section-box-shadow-6);
}
</style>
